
{
  "fr": {
    "configuratorEditorThemeChangeModal": {
      "title": "Vous vous apprêtez à modifier le style de votre gobelet.",
      "content": "Vous perdrez toute la configuration en cours de personnalisation.",
      "confirmButton": "Modifier",
      "cancelButton": "Conserver le visuel actuel"
    }
  }
}
